export const renderFileHeader = (position: number) => {
    switch (position) {
      case 0:
        return 'Terms and Conditions'
      case 1:
        return 'Disclosure Statement'
      case 2:
        return 'Other'
      case 3:
        return 'Contract'
      default:
        return 'File'
    }
  }